import React from 'react';
import { Avatar, Paper, Typography } from '@mui/material';
import AmiLogo from '../../assets/images/Ami Copilot.png';

const ChatMessage = ({ text, isUser }) => {
  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-2`}>
      {/* {!isUser && ( )} */}

      <Paper
        elevation={2}
        className={`w-fit max-w-[75%] rounded-2xl px-4 py-2 border ${
          isUser ? 'bg-[#003748] text-white border-blue-600' : 'bg-gray-900 text-white border-gray-600'
        }`}
        sx={{
          backgroundColor: isUser ? '#003748' : '#1E1E1E',
          color: 'white',
          borderColor: isUser ? '#0077B6' : '#555',
          '&.MuiPaper-root': { backgroundImage: 'none' }
        }}
      >
        {!isUser && (
          <div className="flex mb-2">
            <Avatar
              src={AmiLogo}
              alt="Ami Logo"
              sx={{
                width: 32,
                height: 32,
                marginRight: '0.5rem',
                // backgroundColor: 'rgb(209 213 219)',
                // border: '3px solid #ca8a04',
                // border:'2px solid red',
                padding: '4px',
                flexShrink: 0,
                '& img': {
                  width: '30px',
                  height: '30px'
                }
              }}
            />
            <Typography
              variant="h5"
              component="div"
              className="font-semibold mb-1 text-3xl text-gray-300"
              sx={{ fontWeight: 'bold', fontSize: '4rem' }}
            >
              Ami <span className="text-xs">0.2 βeta</span>
            </Typography>
          </div>
        )}

        <Typography component="p" className="whitespace-pre-wrap  text-lg leading-tight" sx={{ fontSize: '3rem' }}>
          {text?.text2}
        </Typography>
      </Paper>
    </div>
  );
};

export default ChatMessage;
